import React from 'react';
import { Link } from 'react-router-dom';
import { PackageCheckIcon, ShieldCheckIcon, TruckIcon } from 'lucide-react';
import type { WarrantyTier } from '../../data/pricing';
import { useLanguage } from '../../contexts/LanguageContext';
import { warrantyLabel } from '../../utils/pricing';
type WarrantyTagProps = {
  tier: WarrantyTier;
  /** Link the label to the published warranty details. Avoid inside other links/buttons. */
  linked?: boolean;
  /** Show "Free U.S. Shipping by USPS" beside the warranty. */
  withShipping?: boolean;
};
export function WarrantyTag({
  tier,
  linked = false,
  withShipping = false
}: WarrantyTagProps) {
  if (!withShipping) return <WarrantyLabel tier={tier} linked={linked} data-id="element-1055" data-mp="2p0c7sf7yfe8h" />;
  return <span className="inline-flex flex-wrap items-center gap-x-4 gap-y-1.5" data-id="element-1056" data-mp="2txuavozaiz8k">
      <WarrantyLabel tier={tier} linked={linked} data-id="element-1057" data-mp="48jtyso4eoyx" />
      <span className="inline-flex items-center gap-1.5 text-sm text-white" data-id="element-1058" data-mp="49v192gryeus">
        <TruckIcon className="h-4 w-4 shrink-0 text-marine" aria-hidden data-id="element-1059" data-mp="95aa1fzxdkkc" />
        Free U.S. Shipping by USPS
      </span>
      <span className="inline-flex items-center gap-1.5 text-sm text-white" data-id="element-1060" data-mp="1v64alt7oc4iq">
        <PackageCheckIcon className="h-4 w-4 shrink-0 text-marine" aria-hidden data-id="element-1061" data-mp="1q9nheklmazys" />
        Tracked &amp; Insured
      </span>
    </span>;
}
function WarrantyLabel({
  tier,
  linked
}: {
  tier: WarrantyTier;
  linked: boolean;
}) {
  const {
    lang
  } = useLanguage();
  const content = <>
      <ShieldCheckIcon className={`h-4 w-4 shrink-0 ${tier === 'lifetime' ? 'text-marine' : 'text-titanium'}`} aria-hidden data-id="element-1062" data-mp="1ca4imiep50z5" />
      <span className={tier === 'lifetime' ? 'text-white' : ''} data-id="element-1063" data-mp="17gjh4gdw9ov7">{warrantyLabel(tier, lang).label}</span>
    </>;
  const cls = 'inline-flex flex-wrap items-center gap-1.5 text-sm text-titanium';
  if (!linked) return <span className={cls} data-id="element-1064" data-mp="yg4wzkco2fta">{content}</span>;
  return <Link to="/warranty" className={`${cls} underline decoration-white/20 underline-offset-4 transition-colors duration-150 hover:text-white hover:decoration-ice focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice`} data-id="element-1065" data-mp="thjufe9xzk1o">
      {content}
    </Link>;
}